<template>
  <!-- 
    n-config-provider: Naive UI 的全局配置提供者
    - theme: 动态设置主题（亮色/暗色）
    - locale: 可以设置语言（中文/英文等）
  -->
  <n-config-provider :theme="currentTheme">
    <!-- 
      n-message-provider: 提供消息提示功能（成功/错误/警告等）
      n-dialog-provider: 提供对话框功能（确认/警告等）
      必须包裹在 n-config-provider 内部
    -->
    <n-message-provider>
      <n-dialog-provider>
        <!-- 路由视图容器，所有页面会在这里渲染 -->
        <router-view/>
      </n-dialog-provider>
    </n-message-provider>
  </n-config-provider>
</template>

<script lang="ts">
import { defineComponent, computed, provide } from 'vue';
import { darkTheme } from 'naive-ui';
import { useTheme } from './composables/useTheme';

export default defineComponent({
  name: 'App',
  setup() {
    // 使用主题 composable
    const { isDark, toggleTheme } = useTheme();
    
    // 计算当前主题
    const currentTheme = computed(() => isDark.value ? darkTheme : null);
    
    // 向下提供主题状态和切换方法
    provide('isDark', isDark);
    provide('toggleTheme', toggleTheme);
    
    return {
      currentTheme
    };
  }
});
</script>

<style>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 全局字体和背景 */
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: background-color 0.3s, color 0.3s;
}

/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
